import './App.css';
import Desktop from './components/Desktop';

function App() {
  return (
    <div className="App">
      <Desktop />
    </div>
  );
}

export default App;
